const START_DICTATE = 'WEB_CHAT/START_DICTATE';

export default function startDictate() {
  return { type: START_DICTATE };
}

export { START_DICTATE };
